import Text from '@commons/components/Text';
import Flex from '@commons/containers/Flex';
import { ArticleDate, ArticleReadTime } from '@commons/pagebuilder/nodes/Article/MetaData';
import type { DrupalBlock, DrupalReadTime } from '@commons/types/drupal';

// Type definition for the ArticleHeaderMetadataBlock component properties.

type Props = DrupalBlock<{
  date: string;
  readTime: DrupalReadTime;
}>;

/**
 * Plugin block for the Article Header Metadata.
 *
 * Displays the date and read time of a blog post in one block.
 */

const ArticleHeaderMetadataBlock = ({ content }: Props) => {
  const { date, readTime } = content;

  return (
    <Flex gap={8}>
      {date && <ArticleDate date={date} />}
      {date && readTime && (
        <Text color="grey-5" level="label-md" marginBottom="none">
          /
        </Text>
      )}
      {readTime && <ArticleReadTime readTime={readTime} />}
    </Flex>
  );
};

export default ArticleHeaderMetadataBlock;
